import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const MatchScoreQuerySchema = PaginationRequestSchema.extend({
  tournamentFormatId: z.string().optional(),
});
export type MatchScoreQueryDTO = z.infer<typeof MatchScoreQuerySchema>;

export const CreateMatchScoreRequestSchema = z.object({
  tournamentFormatId: z.string().min(1, "El evento de torneo es requerido"),
  matchOrder: z.number().int().min(1, "El número de partido es requerido"),
  homeScore: z.number().int().min(0).default(0),
  awayScore: z.number().int().min(0).default(0),
});
export type CreateMatchScoreRequestDTO = z.infer<typeof CreateMatchScoreRequestSchema>;

export const UpdateMatchScoreRequestSchema = z.object({
  homeScore: z.number().int().min(0).optional(),
  awayScore: z.number().int().min(0).optional(),
});
export type UpdateMatchScoreRequestDTO = z.infer<typeof UpdateMatchScoreRequestSchema>;

export const MatchScoreResponseSchema = z.object({
  id: z.string(),
  tournamentFormatId: z.string(),
  matchOrder: z.number(),
  homeScore: z.number(),
  awayScore: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type MatchScoreResponseDTO = z.infer<typeof MatchScoreResponseSchema>;

export const MatchScoresPaginatedResponseSchema = PaginationResponseSchema(MatchScoreResponseSchema);
export type MatchScoresPaginatedResponseDTO = z.infer<typeof MatchScoresPaginatedResponseSchema>;
